import { render, staticRenderFns } from "./DispatchModal.vue?vue&type=template&id=1f68344e&"
import script from "./DispatchModal.vue?vue&type=script&lang=js&"
export * from "./DispatchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports